const getFilteredExpenseItemList = (value, expenseItemList) => {
  if (value) {
    let filteredValues = expenseItemList?.filter(
      ({ expenseCategoryID }) => expenseCategoryID === value.expenseCategoryID
    );
    if (filteredValues.length === 0) {
      filteredValues = [];
    }
    return filteredValues;
  }
  return expenseItemList;
};

export default getFilteredExpenseItemList;
